var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","text":""}},[_c('v-icon',{on:{"click":function($event){_vm.playMode = (_vm.playMode + 1) % 3}}},[_vm._v(_vm._s(_vm.theIcon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }